import emptyPackage from '../packages/_package'

export default {
    renewals: [],
    created_at: '',
    schedule_next_payment: '',
    schedule_end: '',
    package: emptyPackage,
    recurring_price: 0
}

export const subscriptionStates = [{
    value: 'active',
    variant: 'success',
    text: 'Aktív'
  }, {
    value: 'pending',
    variant: 'warning',
    text: 'Függőben'
  }, {
    value: 'cancelled',
    variant: 'danger',
    text: 'Lejárt'
}]

export function getSubscriptionState(state) {
    var found = _.find(subscriptionStates, currentState => currentState.value === state)
    if(typeof found === 'undefined') {
      return {
        variant: 'secondary',
        text: `Ismeretlen`
      }
    } else {
      return found
    }
}